export const editableFieldsList = [];
export const fieldNameDropDown = [];
export const dropDownMenuUrls = [];

export const reportColumnsDefinitions = [
    {
        label: 'Hour',
        field: 'hour',
        sign: null,
        width: '120px',
        classes: 'adgroup-column',
        filter: true,
        sort: true,
        format: {
            type: 'integer'
        },
        checked: false,
        visible: true,
        canBeFixed: true,
        isMetricValue: false,
        defaultSorting: false,
        isCompareColumn: false,
    }
    ,
    {
        label: 'Date',
        field: 'date',
        sign: null,
        width: '120px',
        classes: 'adgroup-column',
        filter: true,
        sort: true,
        format: {
            type: 'string'
        },
        checked: true,
        visible: true,
        canBeFixed: true,
        isMetricValue: false,
        defaultSorting: false,
        isCompareColumn: true,
    }
    ,
    {
        label: 'Week',
        field: 'week',
        sign: null,
        width: '120px',
        classes: 'adgroup-column',
        filter: true,
        sort: true,
        format: {
            type: 'integer'
        },
        checked: false,
        visible: true,
        canBeFixed: true,
        isMetricValue: false,
        defaultSorting: false,
        isCompareColumn: true,
    }
    ,
    {
        label: 'Month',
        field: 'month',
        sign: null,
        width: '120px',
        classes: 'adgroup-column',
        filter: true,
        sort: true,
        format: {
            type: 'integer'
        },
        checked: false,
        visible: true,
        canBeFixed: true,
        isMetricValue: false,
        defaultSorting: false,
        isCompareColumn: true,
    }
    ,
    {
        label: 'Quarter',
        field: 'quarter',
        sign: null,
        width: '120px',
        classes: 'adgroup-column',
        filter: true,
        sort: true,
        format: {
            type: 'integer'
        },
        checked: false,
        visible: true,
        canBeFixed: true,
        isMetricValue: false,
        defaultSorting: false,
        isCompareColumn: true,
    }
    ,
    {
        label: 'Year',
        field: 'year',
        sign: null,
        width: '120px',
        classes: 'adgroup-column',
        filter: true,
        sort: true,
        format: {
            type: 'string'
        },
        checked: false,
        visible: true,
        canBeFixed: true,
        isMetricValue: false,
        defaultSorting: false,
        isCompareColumn: true,
    }
    ,
    {
        label: 'Market',
        field: 'marketName',
        sign: null,
        width: '120px',
        classes: 'adgroup-column',
        filter: true,
        sort: false,
        format: {
            type: 'string'
        },
        checked: false,
        visible: true,
        canBeFixed: true,
        isMetricValue: false,
        defaultSorting: false,
        isCompareColumn: false,
    }
    ,
    {
        label: 'Site',
        field: 'siteName',
        sign: null,
        width: '120px',
        classes: 'adgroup-column',
        filter: true,
        sort: false,
        format: {
            type: 'string'
        },
        checked: false,
        visible: true,
        canBeFixed: true,
        isMetricValue: false,
        defaultSorting: false,
        isCompareColumn: false,
    }
    ,
    {
        label: 'Network',
        field: 'networkName',
        sign: null,
        width: '120px',
        classes: 'adgroup-column',
        filter: true,
        sort: false,
        format: {
            type: 'string'
        },
        checked: false,
        visible: true,
        canBeFixed: true,
        isMetricValue: false,
        defaultSorting: false,
        isCompareColumn: false,
    }
    ,
    {
        label: 'Site Group',
        field: 'siteGroupName',
        sign: null,
        width: '120px',
        classes: 'adgroup-column',
        filter: true,
        sort: false,
        format: {
            type: 'string'
        },
        checked: false,
        visible: true,
        canBeFixed: true,
        isMetricValue: false,
        defaultSorting: false,
        isCompareColumn: false,
    }
    ,
    {
        label: 'Source',
        field: 'sourceName',
        sign: null,
        width: '120px',
        classes: 'adgroup-column',
        filter: true,
        sort: false,
        format: {
            type: 'string'
        },
        checked: true,
        visible: true,
        canBeFixed: true,
        isMetricValue: false,
        defaultSorting: false,
        isCompareColumn: false,
    }
    ,
    {
        label: 'Campaign',
        field: 'campaignName',
        sign: null,
        width: '120px',
        classes: 'adgroup-column',
        filter: true,
        sort: true,
        format: {
            type: 'string'
        },
        checked: false,
        visible: true,
        canBeFixed: true,
        isMetricValue: false,
        defaultSorting: false,
        isCompareColumn: false,
    }
    ,
    {
        label: 'AdGroup',
        field: 'adGroupName',
        sign: null,
        width: '120px',
        classes: 'adgroup-column',
        filter: true,
        sort: true,
        format: {
            type: 'string'
        },
        checked: false,
        visible: true,
        canBeFixed: true,
        isMetricValue: false,
        defaultSorting: false,
        isCompareColumn: false,
    }
    ,    
    {
        label: 'Device',
        field: 'deviceName',
        sign: null,
        width: '120px',
        classes: 'adgroup-column',
        filter: true,
        sort: false,
        format: {
            type: 'string'
        },
        checked: false,
        visible: true,
        canBeFixed: true,
        isMetricValue: false,
        defaultSorting: false,
        isCompareColumn: false,
    }
    ,
    {
        label: 'Bought',
        field: 'boughtClicks',        
        sign: '',
        width: '100px',
        classes: 'cost-clicks-column',
        filter: true,
        sort: true,
        defaultSortOrder: "DESC",
        format: {
            type: 'integer'
        },
        checked: true,
        visible: true,
        canBeFixed: true,
        isMetricValue: true,
        isCompareColumn: true,
    }
    ,     
    {
        label: 'Inbound Total',
        field: 'totalInboundClicks',
        sign: '',
        width: '100px',
        classes: 'cost-clicks-column',
        filter: true,
        sort: true,
        defaultSortOrder: "DESC",
        format: {
            type: 'integer'
        },
        checked: false,
        visible: true,
        canBeFixed: true,
        isMetricValue: true,
        isCompareColumn: true,
    }
    ,
    {
        label: 'Inbound NBot',
        field: 'nonBotInboundClicks',   
        sign: '',
        width: '100px',
        classes: 'cost-clicks-column',
        filter: true,
        sort: true,
        defaultSortOrder: "DESC",
        format: {
            type: 'integer'
        },
        checked: true,
        visible: true,
        canBeFixed: true,
        isMetricValue: true,
        isCompareColumn: true,
    }
    , 
    {
        label: 'Bought ScrubRate Total',
        field: 'totalInboundScrubRate',   
        sign: '%',
        width: '100px',
        classes: 'cost-clicks-column',
        filter: true,
        sort: true,
        defaultSortOrder: "DESC",
        format: {
            type: 'percentage',
            precision: 2
        },
        checked: false,
        visible: true,
        canBeFixed: true,
        isMetricValue: true,
        isCompareColumn: true,
    }
    ,
    {
        label: 'Bought ScrubRate NBot',
        field: 'nonBotInboundScrubRate',   
        sign: '%',
        width: '100px',
        classes: 'cost-clicks-column',
        filter: true,
        sort: true,
        defaultSortOrder: "DESC",
        format: {
            type: 'percentage',
            precision: 2
        },
        checked: true,
        visible: true,
        canBeFixed: true,
        isMetricValue: true,
        isCompareColumn: true,
    }
    ,
    {
        label: 'opCTR',
        field: 'opCtr',   
        sign: '%',
        width: '100px',
        classes: 'cost-clicks-column',
        filter: true,
        sort: true,
        defaultSortOrder: "DESC",
        format: {
            type: 'percentage',
            precision: 2
        },
        checked: true,
        visible: true,
        canBeFixed: true,
        isMetricValue: true,
        isCompareColumn: true,
    }
    ,
    {
        label: 'opCTR Total',
        field: 'totalOpCtr',   
        sign: '%',
        width: '100px',
        classes: 'cost-clicks-column',
        filter: true,
        sort: true,
        defaultSortOrder: "DESC",
        format: {
            type: 'percentage',
            precision: 2
        },
        checked: false,
        visible: true,
        canBeFixed: true,
        isMetricValue: true,
        isCompareColumn: true,
    }    
    ,
    {
        label: 'opCTR NBot',
        field: 'nonBotOpCtr',   
        sign: '%',
        width: '100px',
        classes: 'cost-clicks-column',
        filter: true,
        sort: true,
        defaultSortOrder: "DESC",
        format: {
            type: 'percentage',
            precision: 2
        },
        checked: true,
        visible: true,
        canBeFixed: true,
        isMetricValue: true,
        isCompareColumn: true,
    }
    ,
    {
        label: 'Partner',
        field: 'partnersNames',
        sign: null,
        width: '120px',
        classes: 'adgroup-column',
        filter: true,
        sort: false,
        format: {
            type: 'string'
        },
        checked: true,
        visible: true,
        canBeFixed: true,
        isMetricValue: false,
        defaultSorting: false,
        isCompareColumn: true,
    }
    ,
    {
        label: 'Sold',
        field: 'soldClicks',
        sign: '',
        width: '100px',
        classes: 'cost-clicks-column',
        filter: true,
        sort: true,
        defaultSortOrder: "DESC",
        format: {
            type: 'integer'
        },
        checked: true,
        visible: true,
        canBeFixed: true,
        isMetricValue: true,
        isCompareColumn: true,
    }
    ,     
    {
        label: 'Outbound Total',
        field: 'totalOutboundClicks',
        sign: '',
        width: '100px',
        classes: 'cost-clicks-column',
        filter: true,
        sort: true,
        defaultSortOrder: "DESC",
        format: {
            type: 'integer'
        },
        checked: false,
        visible: true,
        canBeFixed: true,
        isMetricValue: true,
        isCompareColumn: true,
    }
    ,
    {
        label: 'Outbound NBot',
        field: 'nonBotOutboundClicks',   
        sign: '',
        width: '100px',
        classes: 'cost-clicks-column',
        filter: true,
        sort: true,
        defaultSortOrder: "DESC",
        format: {
            type: 'integer'
        },
        checked: true,
        visible: true,
        canBeFixed: true,
        isMetricValue: true,
        isCompareColumn: true,
    }
    , 
    {
        label: 'Sold ScrubRate Total',
        field: 'totalOutboundScrubRate',   
        sign: '%',
        width: '100px',
        classes: 'cost-clicks-column',
        filter: true,
        sort: true,
        defaultSortOrder: "DESC",
        format: {
            type: 'percentage',
            precision: 2
        },
        checked: false,
        visible: true,
        canBeFixed: true,
        isMetricValue: true,
        isCompareColumn: true,
    }
    ,
    {
        label: 'Sold ScrubRate NBot',
        field: 'nonBotOutboundScrubRate',   
        sign: '%',
        width: '100px',
        classes: 'cost-clicks-column',
        filter: true,
        sort: true,
        defaultSortOrder: "DESC",
        format: {
            type: 'percentage',
            precision: 2
        },
        checked: true,
        visible: true,
        canBeFixed: true,
        isMetricValue: true,
        isCompareColumn: true,
    }
];


// WEBPACK FOOTER //
// ./src/configs/scrubrate-hourly-report-config.js